<template lang="html">
  <v-toolbar app flat color="white">
    <v-toolbar-title class="text-uppercase">
      <span class="font-weight-thin">Thibaud</span>
      <span class="font-weight-medium">Nesztler</span>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn
      icon
      href="https://www.linkedin.com/in/thibaudnesztler/"
      target="_blank"
    >
      <v-icon>mdi-linkedin</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
export default {};
</script>

<style></style>
